<!-- CompetitionsCU.vue -->
<template>
  <div class="container box_component">
    <!-- FORMULARIO -->
    <CompetitionForm
      :types="types"
      :countries="countries"
      :rules="rules"
      :tricklistVersions="tricklistVersions"
      :genders="genders"
      :categories="categories"
      :participants_pack="participants_pack"
      :round_sizes="round_sizes"
      :availableJudges="availableJudges"
      :availableDays="availableDays"
      @update-show-modal="controlPop"
      @show-loading="showLoading"
      @hide-loading="hideLoading"
      @save-form="onSave"
      @cancel-form="onCancel"
      />
  </div>
  <!-- Modal de advertencia -->
  <ConfirmationModal
      ref="confirmationModal"
      :message="modalMessage"
      :showCancel="showCancel"
      @confirmed="confirmModal"
      @canceled="cancelModal"
  />
  <loading-modal ref="loadingModal"></loading-modal>
</template>

<script>
import LoadingModal from "@/services/LoadingModal.vue";
import CompetitionForm from "@/components/competitions/CompetitionForm.vue";
import {mapActions, mapState} from "vuex";
import ConfirmationModal from "@/components/competitions/ConfirmationModal.vue";
export default {
  name: "CompetitionsCU",
  components: {
    ConfirmationModal,
    LoadingModal,
    CompetitionForm
  },
  data() {
    return {
      /* Arryas data */
      round_sizes: [],
      rules: [],
      tricklistVersions: [],
      types: [],
      genders: [
        { value: 'male', name: 'Males only' },
        { value: 'female', name: 'Females only' },
        { value: 'mixed', name: 'Mixed gender' },
      ],
      categories: [
        { value: 'national', name: 'National' },
        { value: 'international', name: 'International' },
        { value: 'team', name: 'Team' },
      ],
      countries: [],
      participants_pack: [
        { value: 'small', name: 'Small Size', min_vs: 8, max_vs: 10, min_sc: 8, max_sc: 12 },
        { value: 'medium', name: 'Medium Size', min_vs: 11, max_vs: 18, min_sc: 13, max_sc: 20 },
        { value: 'big', name: 'Big Size', min_vs: 19, max_vs: 32, min_sc: 21, max_sc: 32 },
      ],
      tensionSystems: [
        "Ratchet",
        "Pulley System",
        "Chain Hoist",
        "Motor System"
      ],
      anchorTypes: [
        "Mechanical",
        "Chemical bolts",
        "Structural elements",
        "Dead-man anchor",
        "HGV (Heavy vehicles >3.5ton)",
        "Weights > 3ton",
        "Skip container",
        "Concrete blocks",
        "Trees",
        "Concrete Anchor",
        "Wooden Posts",
        "Metal Structure",
        "Rock Bolts"
      ],
      mattTypes: [
        "Crash Pad",
        "Gymnastics Mat",
        "Foam Mat",
        "Inflatable Mat",
        "Air Pad",
        "Beach Sand",
        "No mat"
      ],
      frameTypes: [
        "Wooden",
        "Metal",
        "No frame"
      ],
      availableJudges: [
        { value: 1, name: "1 Judge" },
        { value: 2, name: "2 Judges" },
        { value: 3, name: "3 Judges" },
        { value: 4, name: "4 Judges" },
        { value: 5, name: "5 Judges" },
        { value: 6, name: "6 Judges" }
      ],
      availableDays: [
        { value: 10, name: "10 days" },
        { value: 15, name: "15 days" },
        { value: 20, name: "20 days" },
        { value: 30, name: "30 days" }
      ],
      showCancel: false,
      modalMessage:"",
    };
  },
  computed: {
    ...mapState("competition",["competitionIdToView", "competitionIdToEdit", "competitionData"]),
    ...mapState('user', ['isAuthenticated','user','token']),

  },
  mounted() {
    this.loadCountries();
    this.loadData();
  },
  methods: {
    ...mapActions("competition",["clearCompetition","clearCompetitionIdToView","clearCompetitionIdToEdit","setCompetition"]),
    /*Control de tabs*/
    controlPop(message){
      this.modalMessage = message;
      this.$refs.confirmationModal.openModal(); // 🔥 Usa `ref` para abrir el modal
    },
    async confirmModal() {
      console.log("🔥 Modal Confirmado");
    },
    cancelModal() {
      this.selectedCompetitionId = null;
    },
    /*Loading componente*/
    showLoading() {
      this.$nextTick(() => {
        this.$refs.loadingModal.showLoading();
      });
    },
    hideLoading() {
      this.$nextTick(() => {
        this.$refs.loadingModal.hideLoading();
      });
    },
    /*Cargar datos de paises y formulario*/
    async loadCountries() {
      try {
        this.showLoading();
        const response = await this.$axios.get("/countries",{
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
            .catch(error => {
              console.error('Error al obtener la lista de países:', error);
            });
        const countriesData = response.data.countries.map(country => {
          let translatedName = country.name;
          let langCode = this.$i18n.locale;
          if (langCode !== 'en' && country.translations) {
            try {
              const translationsObject = JSON.parse(country.translations);
              if (langCode === 'jp'){langCode = 'ja'}
              translatedName = translationsObject[langCode] || country.name;
            } catch (error) {
              console.error('Error al parsear las traducciones:', error);
            }
          }

          return {
            id: country.id,
            name: translatedName,
            currency_symbol: country.currency_symbol
          };
        });

        this.countries = countriesData.sort((a, b) => {
          const nameA = a.name.toUpperCase();
          const nameB = b.name.toUpperCase();
          return nameA.localeCompare(nameB);
        });
        this.hideLoading();
      } catch (error) {
        console.error('Error loading countries:', error);
      }
    },
    async loadData(){
      try {
        this.showLoading();
        const response = await this.$axios.get(`/competitions`,{
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
            .catch(error => {
              console.error('Error al obtener la lista de países:', error);
            });
        /* const countriesData = response.data.countries.map(country => {
             let translatedName = country.name;
             let langCode = this.$i18n.locale;
             if (langCode !== 'en' && country.translations) {
                 try {
                     const translationsObject = JSON.parse(country.translations);
                     if (langCode === 'jp'){langCode = 'ja'}
                     translatedName = translationsObject[langCode] || country.name;
                 } catch (error) {
                     console.error('Error al parsear las traducciones:', error);
                 }
             }

             return {
                 id: country.id,
                 name: translatedName,
             };
         });
         this.countries = countriesData.sort((a, b) => a.name.localeCompare(b.name));*/

        const mapObjetsCompetition = Objets => {
          return Objets.map(objet => ({
            value: objet.id,
            name: objet.name,
          }));
        };
        this.round_sizes = mapObjetsCompetition(response.data.round_sizes);
        this.rules = mapObjetsCompetition(response.data.rules);
        this.tricklistVersions = mapObjetsCompetition(response.data.tricklist_versions || []);
        this.types = mapObjetsCompetition(response.data.types);
        this.hideLoading();
      } catch (error) {
        console.error('Error loading cities:', error);
      }
    },
    /*grabar en BBDD*/
    async onSave() {
      const allFields = {};
      const localData = this.competitionData || {};

      if (!localData || !localData[0]?.fields?.name || localData[0].fields.name.length === 0) {
        this.controlPop(this.$t("competitions.messages.complete_name"));
        return;
      }

      // 🔹 Convertimos los tabs en un solo objeto de campos
      localData.forEach((tab) => {
        Object.assign(allFields, tab.fields);
      });

      this.showLoading();

      try {
        const competitionId = this.competitionIdToEdit; // Obtiene el ID de edición si existe

        let response;
        if (competitionId) {
          // 🔹 Modo Edición (PUT)
          response = await this.$axios.put(`/competitions/${competitionId}`, {
            formUpdate: allFields
          }, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          });
        } else {
          // 🔹 Modo Creación (POST)
          response = await this.$axios.post(`/competitions/store`, {
            formCreate: allFields
          }, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          });
        }

        if (response.status === 200 || response.status === 201) {
          this.cleanSession();
          this.$router.push('/competitions'); // Redirigir tras éxito
        }

      } catch (error) {
        console.error("❌ Error al guardar la competición:", error);
      } finally {
        this.hideLoading();
      }
    },
    /*salir de seccion*/
    onCancel() {
      this.cleanSession();
      this.$router.push('/competitions');
    },
    cleanSession(){
      this.clearCompetition();
      this.clearCompetitionIdToView();
      this.clearCompetitionIdToEdit();
    }
  },

};
</script>

<style scoped>
.box_component {
  width: 100%;
  max-width: 100%;
  margin: 15px auto;
  overflow-x: hidden !important;
}
@media (max-width: 576px) {

}
@media (max-width: 768px) {

}
</style>
